/**
 * Shared surgical update utilities for HTML Editor components
 */

/**
 * Create a surgical update for CSS class properties
 */
export const createCSSClassUpdate = (className, properties) => {
  // Convert properties object to CSS content
  const cssContent = Object.entries(properties)
    .filter(([key, value]) => value && value.toString().trim() && key !== 'background-image-cdn')
    .map(([key, value]) => `  ${key}: ${value.toString().trim()};`)
    .join('\n')

  return {
    type: 'css-class',
    selector: className,
    content: cssContent
  }
}

/**
 * Create a surgical update for a single CSS property
 */
export const createCSSPropertyUpdate = (className, property, value) => {
  // Ensure selector has the CSS class prefix
  const selector = className.startsWith('.') ? className : `.${className}`

  return {
    type: 'css-property',
    selector: selector,
    property: property,
    value: value
  }
}

/**
 * Create a surgical update for renaming a CSS class
 */
export const createCSSClassRenameUpdate = (oldClassName, newClassName, properties) => {
  const cssContent = Object.entries(properties)
    .filter(([key, value]) => value && value.toString().trim() && key !== 'background-image-cdn')
    .map(([key, value]) => `  ${key}: ${value.toString().trim()};`)
    .join('\n')

  return {
    type: 'css-class-rename',
    oldSelector: oldClassName,
    newSelector: newClassName,
    content: cssContent
  }
}

/**
 * Create a surgical update for deleting a CSS class
 */
export const createCSSClassDeleteUpdate = (className) => {
  return {
    type: 'css-class-delete',
    selector: className
  }
}

/**
 * Publish surgical updates via PubSub
 */
export const publishSurgicalUpdates = (updates, source, PubSub) => {
  if (!PubSub) {
    console.error("PubSub is required for publishing surgical updates")
    return
  }

  const payload = {
    updates: Array.isArray(updates) ? updates : [updates],
    source: source
  }

  PubSub.publish("html-editor:content-update", payload)
}